import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import ConvertDate from "../common/ConvertDate";
import "./DatePickerField.css";
import { Tooltip } from "@mui/material";

const DatePickerField = ({
  name,
  formik,
  label,
  disabled,
  hasToolTip,
  tooltipText,
  reqiuerd,
}) => {
  return (
    <div className="flex flex-col h-24">
      {hasToolTip ? (
        <Tooltip title={tooltipText} placement="top">
          <label className="mb-2 text-xs md:text-sm">
            {label} {reqiuerd ? <span className="text-red-700">*</span> : ""}
          </label>
        </Tooltip>
      ) : (
        <label className="mb-2 text-xs md:text-sm">
          {label} {reqiuerd ? <span className="text-red-700">*</span> : ""}
        </label>
      )}

      <DatePicker
        disabled={disabled}
        className=""
        label={name}
        id={name}
        name={name}
        placeholder="انتخاب تاریخ"
        value={formik.values[name]}
        onChange={(value) => {
          let datePicked = ConvertDate(value.unix * 1000);
          formik.setFieldValue(name, datePicked.props.children);
        }}
        format={"YYYY/MM/DD"}
        calendar={persian}
        locale={persian_fa}
        minDate={new Date()}
      />
    </div>
  );
};
export default DatePickerField;
